import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "view1" }
const _hoisted_2 = { class: "view2 radius-view1 main-view" }
const _hoisted_3 = { class: "freightTemplateAdd1" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
}
const _hoisted_6 = { style: {"margin-top":"20px"} }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
}
const _hoisted_9 = { style: {"margin-top":"20px"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
}

export function render(_ctx, _cache) {
  const _component_el_page_header = _resolveComponent("el-page-header")
  const _component_el_alert = _resolveComponent("el-alert")
  const _component_mi_title = _resolveComponent("mi-title")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_page_header, {
        onBack: _ctx.back,
        title: "返回",
        content: "添加景点",
        style: {"margin-bottom":"20px"}
      }, null, 8, ["onBack"]),
      _createVNode(_component_el_alert, {
        style: {"margin-bottom":"30px"},
        closable: false,
        title: "添加的景点信息！",
        type: "warning"
      }),
      _createVNode(_component_el_form, {
        ref: "refForm",
        model: _ctx.ruleForm,
        rules: _ctx.rules,
        "label-width": "100px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_mi_title, { text: "景点信息" }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_form_item, {
              label: "守护精灵",
              class: "form-item",
              prop: "jinglingId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.ruleForm.jinglingId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.ruleForm.jinglingId) = $event)),
                  class: "form-item-view",
                  placeholder: "守护精灵"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jingdianFiles, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "景点介绍",
              prop: "jingdianFiles"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { type: "flex" }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createElementVNode("div", null, " 语言：中文 ", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_row, { type: "flex" }, {
                  default: _withCtx(() => [
                    _cache[12] || (_cache[12] = _createElementVNode("div", null, " 类型： ", -1)),
                    _createVNode(_component_el_select, {
                      placeholder: "请选择介绍类型",
                      modelValue: _ctx.ruleForm.jingdianFiles[0].type,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.ruleForm.jingdianFiles[0].type) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: 0,
                          label: "语音"
                        }),
                        _createVNode(_component_el_option, {
                          value: 1,
                          label: "视频"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _cache[14] || (_cache[14] = _createElementVNode("div", null, " 文件： ", -1)),
                    _createVNode(_component_el_upload, {
                      class: "dl-avatar-uploader-min square",
                      action: _ctx.uploadUrl,
                      data: _ctx.uploadData,
                      "show-file-list": false,
                      "on-success": _ctx.handleUpImage3,
                      "before-upload": _ctx.beforeImageUpload,
                      accept: _ctx.ruleForm.jingdianFiles[0].type==0?'audio/*':'video/*'
                    }, {
                      tip: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createElementVNode("div", { class: "el-upload__tip" }, "只能上传音乐/视频文件,大小不能超过50MB", -1)
                      ])),
                      default: _withCtx(() => [
                        (_ctx.ruleForm.jingdianFiles[0].url)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.ruleForm.jingdianFiles[0].url), 1))
                          : (_openBlock(), _createElementBlock("i", _hoisted_5))
                      ]),
                      _: 1
                    }, 8, ["action", "data", "on-success", "before-upload", "accept"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_row, { type: "flex" }, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createElementVNode("div", null, " 语言：日语 ", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { type: "flex" }, {
                    default: _withCtx(() => [
                      _cache[16] || (_cache[16] = _createElementVNode("div", null, " 类型： ", -1)),
                      _createVNode(_component_el_select, {
                        placeholder: "请选择介绍类型",
                        modelValue: _ctx.ruleForm.jingdianFiles[1].type,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.ruleForm.jingdianFiles[1].type) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            value: 0,
                            label: "语音"
                          }),
                          _createVNode(_component_el_option, {
                            value: 1,
                            label: "视频"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _cache[18] || (_cache[18] = _createElementVNode("div", null, " 文件： ", -1)),
                      _createVNode(_component_el_upload, {
                        class: "dl-avatar-uploader-min square",
                        action: _ctx.uploadUrl,
                        data: _ctx.uploadData,
                        "show-file-list": false,
                        "on-success": _ctx.handleUpImage4,
                        "before-upload": _ctx.beforeImageUpload,
                        accept: _ctx.ruleForm.jingdianFiles[1].type==0?'audio/*':'video/*'
                      }, {
                        tip: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createElementVNode("div", { class: "el-upload__tip" }, "只能上传音乐/视频文件,大小不能超过50MB", -1)
                        ])),
                        default: _withCtx(() => [
                          (_ctx.ruleForm.jingdianFiles[1].url)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.ruleForm.jingdianFiles[1].url), 1))
                            : (_openBlock(), _createElementBlock("i", _hoisted_8))
                        ]),
                        _: 1
                      }, 8, ["action", "data", "on-success", "before-upload", "accept"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_row, { type: "flex" }, {
                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                      _createElementVNode("div", null, " 语言：英语 ", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { type: "flex" }, {
                    default: _withCtx(() => [
                      _cache[20] || (_cache[20] = _createElementVNode("div", null, " 类型： ", -1)),
                      _createVNode(_component_el_select, {
                        placeholder: "请选择介绍类型",
                        modelValue: _ctx.ruleForm.jingdianFiles[2].type,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.ruleForm.jingdianFiles[2].type) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            value: 0,
                            label: "语音"
                          }),
                          _createVNode(_component_el_option, {
                            value: 1,
                            label: "视频"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _cache[22] || (_cache[22] = _createElementVNode("div", null, " 文件： ", -1)),
                      _createVNode(_component_el_upload, {
                        class: "dl-avatar-uploader-min square",
                        action: _ctx.uploadUrl,
                        data: _ctx.uploadData,
                        "show-file-list": false,
                        "on-success": _ctx.handleUpImage5,
                        "before-upload": _ctx.beforeImageUpload,
                        accept: _ctx.ruleForm.jingdianFiles[2].type==0?'audio/*':'video/*'
                      }, {
                        tip: _withCtx(() => _cache[21] || (_cache[21] = [
                          _createElementVNode("div", { class: "el-upload__tip" }, "只能上传音乐/视频文件,大小不能超过50MB", -1)
                        ])),
                        default: _withCtx(() => [
                          (_ctx.ruleForm.jingdianFiles[2].url)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.ruleForm.jingdianFiles[2].url), 1))
                            : (_openBlock(), _createElementBlock("i", _hoisted_11))
                        ]),
                        _: 1
                      }, 8, ["action", "data", "on-success", "before-upload", "accept"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "景点名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { type: "flex" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      placeholder: "请输入景点名称",
                      modelValue: _ctx.ruleForm.name,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.ruleForm.name) = $event)),
                      style: {"width":"80%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "景点类型",
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择景点类型",
                  modelValue: _ctx.ruleForm.type,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.ruleForm.type) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: 0,
                      label: "范围景点"
                    }),
                    _createVNode(_component_el_option, {
                      value: 1,
                      label: "敲门景点"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.ruleForm.type==0)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "经度",
                  prop: "lng"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { type: "flex" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "number",
                          placeholder: "请输入景点所在经度",
                          modelValue: _ctx.ruleForm.lng,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.ruleForm.lng) = $event)),
                          style: {"width":"80%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.ruleForm.type==0)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "纬度",
                  prop: "lat"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { type: "flex" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "number",
                          placeholder: "请输入景点所在纬度",
                          modelValue: _ctx.ruleForm.lat,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.ruleForm.lat) = $event)),
                          style: {"width":"80%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.ruleForm.type==0)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: "景点范围(米)",
                  prop: "distance"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { type: "flex" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "number",
                          placeholder: "请输入景点范围（距离多少米显示）",
                          modelValue: _ctx.ruleForm.distance,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.ruleForm.distance) = $event)),
                          style: {"width":"80%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_form_item, { style: {"margin-top":"20px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[9] || (_cache[9] = $event => (_ctx.submitForm(_ctx.ruleForm)))
              }, {
                default: _withCtx(() => _cache[23] || (_cache[23] = [
                  _createTextVNode("立即添加")
                ])),
                _: 1
              }),
              _createVNode(_component_el_button, {
                onClick: _cache[10] || (_cache[10] = $event => (_ctx.resetForm('refForm')))
              }, {
                default: _withCtx(() => _cache[24] || (_cache[24] = [
                  _createTextVNode("重置")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}